<div *ngIf="selectedPackage$ | async; else error" [ngClass]="{ 'offer-with-toolbox': showToolbox }" class="offer">
  <div class="offer-name">
    <h4 nxHeadline="subsection-xsmall" class="offer-name--label">
      <b>
        {{ 'offer.package' | translate }}
      </b>
    </h4>
    <h2 nxHeadline="page-bold-caps" class="offer-name--name">{{ (selectedPackage$ | async)?.name }}</h2>
  </div>
  <div class="offer-price">
    <app-price-tag
      [amount]="(offerValue$ | async) || 0"
      [amountBeforeDiscount]="(offerValueBeforeDiscounts$ | async) || null"
      [currency]="(selectedPackage$ | async)?.totalValue?.currency || 'pln'"
    />
    <app-error *ngIf="(premiumCalculationState$ | async) === apiState.error" />
    <div *ngIf="discountCodeIsValid$ | async" class="offer-price--discount">
      <qbe-custom-icons class="offer-price--icon" [icon]="qbeIcons.BestOffert"></qbe-custom-icons>
      <p nxCopytext="normal" class="offer-price--description">{{ 'offer.discount.info-description' | translate }}&#185;</p>
    </div>
  </div>
  <div class="offer-coverage">
    <h4 nxHeadline="subsection-xsmall" class="nx-margin-bottom-s">
      <b>
        {{ 'offer.offerProtection.title' | translate }}
      </b>
    </h4>
    <div class="nx-margin-bottom-s">
      <app-offer-table [coverages]="(selectedPackage$ | async)?.coverages || []" />
    </div>

    <button
      *ngIf="!(isResignation$ | async)"
      (click)="showCompareOffersModal()"
      nxPlainButton
      type="button"
      class="nx-margin-right-m offer-compare-offers-btn"
    >
      <nx-icon name="file-text" class="nx-margin-right-2xs"></nx-icon>
      <span class="offer-compare-offers-btn-label"> {{ 'offer.compare-offers.btn' | translate }} </span>
    </button>

    <ng-container *ngIf="isResignation$ | async">
      <div *ngIf="(selectedPackage$ | async)?.addOns | isNotEmpty" class="offer-addons--wrapper nx-margin-top-2m">
        <div
          *ngFor="let addon of (selectedPackage$ | async)?.addOns"
          class="flex flex-col gap-8"
          [ngClass]="{ active: (packageAddons$ | async)?.state?.[addon.codeName] || false }"
        >
          <p nxCopytext="normal">{{ addon.premiumInformation }}</p>
          <div class="addon-content flex items-start">
            <div class="addon-switcher">
              <nx-switcher
                (checkedChange)="changeSwitcher($event, addon.codeName)"
                [checked]="(packageAddons$ | async)?.state?.[addon.codeName] ?? addon.defaultSelected"
                [disabled]="(premiumCalculationState$ | async) === apiState.pending"
                name="add-ons"
              >
                <span
                  ><b>
                    {{ addon.name | resignationAddonName }}
                  </b>
                  {{ addon.description ? ' - ' + addon.description : '' }}
                </span>
              </nx-switcher>
            </div>

            <button
              *ngIf="addon.additionalInformation"
              nxIconButton="tertiary small"
              type="button"
              (click)="showAddOnsModal(addon)"
              class="nx-popover__button nx-margin-right-3xs"
            >
              <nx-icon name="info-circle-o" size="s" aria-hidden="true"> </nx-icon>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="offer-addons">
    <ng-container *ngIf="!(isResignation$ | async)">
      <h4 nxHeadline="subsection-xsmall" class="nx-margin-bottom-s">
        <b>
          {{ 'offer.addOns.title' | translate }}
        </b>
      </h4>
      <div *ngIf="(selectedPackage$ | async)?.addOns | isNotEmpty" class="offer-addons--wrapper nx-margin-bottom-2m">
        <div
          *ngFor="let addon of (selectedPackage$ | async)?.addOns"
          class="offer-addons--element"
          [ngClass]="{ active: (packageAddons$ | async)?.state?.[addon.codeName] || false }"
        >
          <div *ngIf="addon.highlighted" class="badge">
            {{ 'offer.addOns.badge' | translate }}
          </div>
          <div class="addon-content">
            <div class="addon-switcher">
              <nx-switcher
                (checkedChange)="changeSwitcher($event, addon.codeName)"
                [checked]="(packageAddons$ | async)?.state?.[addon.codeName] ?? addon.defaultSelected"
                [disabled]="(premiumCalculationState$ | async) === apiState.pending"
                name="add-ons"
              >
                <b>
                  {{ addon.name }}
                </b>
              </nx-switcher>
            </div>
            <div class="addon-description">
              <p nxCopytext="medium">
                {{ addon.premiumInformation }}
              </p>
              <button (click)="showAddOnsModal(addon)" nxPlainButton type="button" class="add-ons-button">
                {{ 'offer.addOns.more' | translate }}
              </button>
              <div *ngIf="isAppAgentOrTravelAgency" class="add-ons-customize">
                <div [ngSwitch]="addon.codeName">
                  <ng-container *ngSwitchCase="'AlcoholIncluded'">
                    <button
                      (click)="showCustomizeAlcoholIncludedModal()"
                      nxPlainButton
                      type="button"
                      class="add-ons-button"
                      [disabled]="(premiumCalculationState$ | async) === apiState.pending"
                    >
                      {{ 'offer.addOns.customize.button' | translate }}
                    </button>
                    <span *ngIf="numberOfCustomizeAlcoholIncludedPersons$ | async" class="add-ons-button_label">
                      {{
                        'offer.addOns.customize.label' | translate : { numberOfPersons: numberOfCustomizeAlcoholIncludedPersons$ | async }
                      }}
                    </span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'ForTheActive'">
                    <button
                      (click)="showCustomForTheActiveModal()"
                      nxPlainButton
                      type="button"
                      class="add-ons-button"
                      [disabled]="(premiumCalculationState$ | async) === apiState.pending"
                    >
                      {{ 'offer.addOns.customize.button' | translate }}
                    </button>
                    <span
                      *ngIf="numberOfCustomizeForTheActivePersons$ | async as numberOfCustomizeForTheActivePersons"
                      class="add-ons-button_label"
                    >
                      {{ 'offer.addOns.customize.label' | translate : { numberOfPersons: numberOfCustomizeForTheActivePersons } }}
                    </span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div class="addon-price">
            <p nxCopytext="normal">
              {{ addon.premium.amount | aztCurrency : addon.premium.currency }}
            </p>
          </div>
        </div>
      </div>
    </ng-container>

    <div *ngFor="let extendedInfo of (selectedPackage$ | async)?.extendedInformation" class="nx-margin-bottom-2m">
      <p nxCopytext="large" class="nx-margin-right-2xs">
        {{ extendedInfo.name }}
      </p>
      <ul nxList class="nx-margin-bottom-2xs">
        <li *ngFor="let extendedInfo of extendedInfo.additionalInformations.additionalInfoItems">
          {{ extendedInfo }}
        </li>
      </ul>
      <button
        *ngIf="isExtendedInfoModal(extendedInfo)"
        (click)="showExtendedInfoModal(extendedInfo)"
        nxPlainButton
        type="button"
        class="extended-info-btn"
      >
        <nx-icon name="file-text" class="nx-margin-right-2xs"></nx-icon>
        <span class="label"> {{ getExtraInfoButtonTranslation(extendedInfo) | translate }} </span>
      </button>
    </div>

    <div class="offer-discount">
      <app-discount-code />
    </div>
  </div>
</div>

<ng-template #addOnTemplate let-data>
  <div nxModalContent class="modal-template">
    <h3 nxHeadline="subsection-medium" class="modal-template-header">{{ data.header }}</h3>
    <p nxCopytext="normal">{{ data.description }}</p>
    <qbe-table *ngIf="data.tableData" [data]="data.tableData" [colBackgroundColors]="data.colBackgroundColors"></qbe-table>
    <div class="nx-margin-top-m">
      <app-modal-close></app-modal-close>
    </div>
  </div>
</ng-template>

<ng-template #extendedInfoTemplate let-data>
  <div nxModalContent>
    <h3 nxHeadline="subsection-medium" class="modal-template-header">
      {{ 'offer.extendedInfo.modal.header' | translate }}
    </h3>
    <ul nxList class="modal-template-list">
      <li *ngFor="let extendedInfo of data">
        {{ extendedInfo }}
      </li>
    </ul>
  </div>
  <div class="modal-template-btn-wrapper">
    <button nxButton (click)="closeExtendedInfoModal()">
      {{ 'offer.extendedInfo.modal.btn' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #error>
  <app-error />
</ng-template>
